import axios from "axios";

export default {
    markTaskNotificationsSeen: async (taskId) => {
        const { data } = await axios.post(`/task/mark_notifications_seen/${taskId}`)

        return data
    }
}
